const piFilterLabels = {
  auctionId: { label: 'ID Anunț', placeholder: 'Ex: PI1004388' },
  auctionTitle: { label: 'Titlu', placeholder: 'Caută după titlu...' },
  publishedDate: { label: 'Data Publicării', placeholder: 'Selectează data' },
  cpvCode: { label: 'Cod CPV', placeholder: 'Ex: 45200000-9' },
  authorityName: { label: 'Autoritate Contractantă', placeholder: 'Ex: Municipiul Timisoara' },
  authorityCUI: { label: 'CUI Autoritate', placeholder: 'Ex: 14756536' },
  city: { label: 'Oraș', placeholder: 'Ex: Timisoara' },
  county: { label: 'Județ', placeholder: 'Selectează județ' },
  minEstimatedValue: { label: 'Valoare Minimă', placeholder: 'Ex: 100000' },
  maxEstimatedValue: { label: 'Valoare Maximă', placeholder: 'Ex: 5000000' },
  currency: { label: 'Monedă', placeholder: 'Ex: RON' },
  contractType: { label: 'Tip Contract', placeholder: 'Lucrari / Servicii' },
};

export default piFilterLabels;
